import type { Dictionary } from './types'
import { en } from './en'
import { es } from './es'

export const dictionary: Dictionary = { es, en }
